import { usStates } from './states'

export const getStateObjectFromSlug = (slug: string) => {
  return usStates.find((state) => state.value.toLowerCase() === slug) || null
}
